import React, { Component } from "react";

import TreeView from "@zippytech/react-toolkit/TreeView";
import uniqid from "uniqid";
import "@zippytech/react-toolkit/TreeView/index.css";
import MenuNode from "./MenuNode";
import { dispatch } from "@rematch/core";
import { toastr } from 'react-redux-toastr';

import { Icon } from "semantic-ui-react";

var colors = require('./../../../../../common/color.json');

let treeData = [];
let appendClass;
class PracticeFlowTreePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateTime: new Date(),
            setEditMode: false,
            lastClicked: 0,
            resourcePaneOpen: true
        };
        this.inputValidation = this.inputValidation.bind(this);
        this.handlePeer = this.handlePeer.bind(this);
        this.filterColor = this.filterColor.bind(this);
    }

    filterColor = (data) => {
        let currentColor = colors.join(',').split(',');
        let relatedCommunity = this.props.selectedPracticeLibrary.communities;


        if (relatedCommunity.length > 0) {
            for (let i = 0; i < relatedCommunity.length; i++) {
                let colorIndex = currentColor.indexOf(relatedCommunity[i].tagColor);

                if (colorIndex != -1) {
                    currentColor.splice(colorIndex, 1)
                }

                if (relatedCommunity[i].communities.length > 0) {

                    for (let j = 0; j < relatedCommunity[i].communities.length; j++) {
                        let colorIndex = currentColor.indexOf(relatedCommunity[i].communities[j].tagColor);

                        if (colorIndex != -1) {
                            currentColor.splice(colorIndex, 1)
                        }
                    }
                }
            }
        }
    }

    handleAdd = (e, data) => {

        let parentId;
        let treeData = this.props.selectedPracticeLibrary[this.props.elements];
        const element = this.props.elements;

        let currentColor = colors.join(',').split(',');
        let relatedCommunity = this.props.selectedPracticeLibrary.communities;


        if (relatedCommunity.length > 0) {
            for (let i = 0; i < relatedCommunity.length; i++) {
                let colorIndex = currentColor.indexOf(relatedCommunity[i].tagColor);

                if (colorIndex != -1) {
                    currentColor.splice(colorIndex, 1)
                }

                if (relatedCommunity[i].communities.length > 0) {

                    for (let j = 0; j < relatedCommunity[i].communities.length; j++) {
                        let colorIndex = currentColor.indexOf(relatedCommunity[i].communities[j].tagColor);

                        if (colorIndex != -1) {
                            currentColor.splice(colorIndex, 1)
                        }
                    }
                }
            }
        }

        const addToDataNode = function (treeData, id) {
            parentId = id;
            treeData.forEach(function (treeNode) {
                if (treeNode.id === id) {
                    if (!treeNode[element]) {
                        treeNode[element] = [];
                    }
                    treeNode[element].push({
                        name: (this.props.elements === 'activities' ? "New Stage" : "New Sub Group")
                    });
                } else {
                    if (treeNode[element] && treeNode[element].length) {
                        addToDataNode(treeNode[element], id);
                    }
                }
            });
        }.bind(this);
        addToDataNode(treeData, data.id);
        const nodeToAdd = {
            name: (this.props.elements === 'activities' ? "New Stage" : "New Sub Group"),
            description: (this.props.elements === 'activities' ? "New Stage" : "New Sub Group"),
            packId: this.props.selectedPracticeLibrary._id,
            branchID: this.props.selectedPracticeLibrary.branches[0],
            lastUpdatedBy: this.props.user,
            tagColor: currentColor[Math.floor(Math.random() * currentColor.length)],
            isParentNode: true,
            accountId: this.props.selectedPracticeLibrary.accountId,
            organizationId: this.props.selectedPracticeLibrary.organizationId
        };
        if (this.props.elements === 'activities') {
            nodeToAdd.parentActivity = parentId;
            nodeToAdd.duration = 0;
        }
        else if (this.props.elements === 'communities') {
            nodeToAdd.parentCommunity = parentId;
        }

        this.props.addAction(nodeToAdd);
        this.setState({
            updateTime: new Date()
        });
    };

    handlePeer = (e, data) => {
        let treeData = this.props.selectedPracticeLibrary[this.props.elements];
        const element = this.props.elements;
        const getParentNode = function (treeData, parentId, childId) {
            for (let index = 0; index < treeData.length; index++) {
                let treeNode = treeData[index];
                const currentNodeId = treeNode._id;
                if (currentNodeId && currentNodeId.toString() === childId.toString()) {
                    return { parentId, index };
                } else {
                    if (treeNode[element] && treeNode[element].length) {
                        const result = getParentNode(
                            treeNode[element],
                            currentNodeId,
                            childId
                        );
                        if (result) {
                            return result;
                        }
                    }
                }
            }
        };

        const addDataNodeToParent = function (treeData, parentId, dataNode) {
            if (parentId === "root") {
                treeData.push(dataNode);
            } else {
                treeData.forEach(function (treeNode) {
                    if (treeNode.id === parentId) {
                        treeNode[this.props.elements].push(dataNode);
                    } else {
                        if (treeNode[this.props.elements] && treeNode[this.props.elements].length) {
                            addDataNodeToParent(treeNode[this.props.elements], parentId, dataNode);
                        }
                    }
                });
            }
        };

        const targetNodeData = getParentNode(treeData, "root", data.id);
        // START-----------------------------------------------------------
        const nodeToAdd = {
            name: (this.props.elements === 'activities' ? "Phase " : "Group ") + (this.props.selectedPracticeLibrary[this.props.elements].length + 1),
            description: (this.props.elements === 'activities' ? "Phase " : "Group ") + (this.props.selectedPracticeLibrary[this.props.elements].length + 1),
            packId: this.props.selectedPracticeLibrary._id,
            branchID: this.props.selectedPracticeLibrary.branches[0],
            tagColor: "#ffffff",
            lastUpdatedBy: this.props.user,
            isParentNode: true,
            duration: 0,
            accountId: this.props.selectedPracticeLibrary.accountId,
            organizationId: this.props.selectedPracticeLibrary.organizationId
        };

        this.props.addAction(nodeToAdd);
        //END-----------------------------------------------------------------
        // addDataNodeToParent(treeData, targetNodeData.parentId, nodeToAdd);
        this.setState({
            updateTime: new Date()
        });
    };

    treeDnDAction = (sourceId, targetId) => {
        if (!sourceId || sourceId.length != 24) return;
        let treeData = this.props.selectedPracticeLibrary[this.props.elements];
        const element = this.props.elements;
        const getParentNode = function (treeData, parentId, childId, depth) {
            for (let index = 0; index < treeData.length; index++) {
                let treeNode = treeData[index];
                if (treeNode) {
                    const currentNodeId = treeNode._id;
                    if (currentNodeId.toString() === childId.toString()) {
                        return { parentId, index, depth };
                    } else {
                        if (treeNode[element] && treeNode[element].length) {
                            const result = getParentNode(
                                treeNode[element],
                                currentNodeId,
                                childId,
                                depth + 1
                            );
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            }
        };
        const getDataNodeById = function (treeData, id, depth) {
            for (let index = 0; index < treeData.length; index++) {
                let treeNode = treeData[index];
                if (treeNode) {
                    const currentNodeId = treeNode._id;
                    if (currentNodeId === id) {
                        return { node: Object.assign({}, treeNode), depth };
                    } else {
                        if (treeNode[element] && treeNode[element].length) {
                            const result = getDataNodeById(treeNode[element], id, depth + 1);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            }
        };

        const addDataNodeToParent = function (treeData, parentId, dataNode, index) {
            if (parentId === "root" || ((!dataNode.parentActivity || dataNode.parentActivity === 'root') && (!dataNode.parentCommunity || dataNode.parentCommunity === 'root'))) {
                treeData.splice(index, 0, dataNode);
            } else {

                treeData.forEach(function (treeNode) {
                    if (treeNode) {
                        if (treeNode._id === parentId) {
                            treeNode[element].splice(index, 0, dataNode);
                        } else {
                            if (treeNode[element] && treeNode[element].length) {
                                addDataNodeToParent(
                                    treeNode[element],
                                    parentId,
                                    dataNode,
                                    index
                                );
                            }
                        }
                    }
                });
            }
        };
        let currentParent;
        const deleteDataNodeById = function (treeData, id, parent) {
            for (let i = treeData.length - 1; i >= 0; i--) {
                let treeNode = treeData[i];
                if (treeNode) {
                    if (treeNode._id === id) {
                        treeData.splice(i, 1);
                        currentParent = parent;
                        return;
                    } else {
                        if (treeNode[element] && treeNode[element].length) {
                            deleteDataNodeById(treeNode[element], id, treeNode._id);
                        }
                    }
                }
            }
        };
        const nodeCopyData = getDataNodeById(treeData, sourceId, 0);
        let parentId = nodeCopyData && nodeCopyData.node.parentActivity ? nodeCopyData.node.parentActivity === 'root' ? 'root' : targetId : nodeCopyData.node.parentCommunity ? nodeCopyData.node.parentCommunity === 'root' ? 'root' : targetId : 'root';
        const targetNodeData = getParentNode(treeData, parentId, targetId, 0);
        const targetNodeDepth = targetNodeData.depth;

        const nodeCopy = nodeCopyData.node;
        const sorceNodeDepth = nodeCopyData.depth;

        if (targetNodeDepth <= sorceNodeDepth) {
            deleteDataNodeById(treeData, sourceId, 'root');
            addDataNodeToParent(
                treeData,
                targetNodeData.parentId,
                nodeCopy,
                targetNodeData.index
            );
            if (this.props.elements === 'activities') {
                nodeCopy.parentActivity = currentParent;
            } else if (this.props.elements === 'communities') {
                nodeCopy.parentCommunity = currentParent;
            }


            this.props.changeIndexAction({ nodeToMove: nodeCopy, target: targetNodeData.parentId, indexInTarget: targetNodeData.index, selectedPracticeLibrary: this.props.selectedPracticeLibrary._id });
            this.setState({
                updateTime: new Date()
            });
        }
    };



    handleDelete = (e, data) => {
        const element = this.props.elements;
        const deleteDataNode = function (treeData, id) {
            for (let i = treeData.length - 1; i >= 0; i--) {
                let treeNode = treeData[i];
                if (treeNode.id === id) {

                    treeData.splice(i, 1);
                    return;
                } else {
                    if (treeNode[element] && treeNode[element].length) {
                        deleteDataNode(treeNode[element], id);
                    }
                }
            }
        };
        let elementName = ""
        let errorMessage = "";
        if (element === "activities") {
            elementName = "Activity"
            errorMessage = "When deleting activity, if child activities exists, they will be deleted. Are you sure you want to proceed?"
        } else if (element === "communities" && data.isLeafCommunity) {
            elementName = "Community"
            errorMessage = `Role ${data.name} will be deleted. Are you sure you want to proceed?`
        } else if (element === "communities" && !data.isLeafCommunity) {
            elementName = "Community"
            errorMessage = "When deleting group, if roles exists, they will be deleted. Are you sure you want to proceed?"
        } else {
            errorMessage = ""
        }

        toastr.confirm(errorMessage, {
            onOk: () => {
                this.props.deleteAction({
                    packId: this.props.selectedPracticeLibrary._id,
                    organizationId: this.props.selectedPracticeLibrary.organizationId,
                    id: data.id,
                    type: 'remove'
                });
                dispatch.lifeCycle.showResourecePane(null);
            }
        });


        deleteDataNode(treeData, data.id);
        this.setState({
            updateTime: new Date()
        });
    };

    dataChanged = (event, data) => {
        if (event.message.length < 129) {
            const updatedName = event.message;
            // START-----------------------------------------------------------
            const nodeToAdd = {
                id: data.id,
                name: updatedName,
                description: "New Phase",
                packId: this.props.selectedPracticeLibrary._id,
                branchID: this.props.selectedPracticeLibrary.branches[0],
                lastUpdatedBy: this.props.user

            };
            this.props.updateAction(nodeToAdd);
            //END-----------------------------------------------------------------
            this.setState({
                updateTime: new Date()
            });
        } else {
            toastr.error('Message', 'Character Max limit is 128.')

        }



    };
    inputValidation(text, id) {
        return true;

    }

    onSelectionChange(selectedMap) {

        dispatch.app.setCollapsedResourcePaneIndexTemp(null);

        if (this.props.setUniqueId === selectedMap.node.label.props.id) {

            if (this.state.lastClicked + 1000 < new Date().getTime()) {
                this.setState({ setEditMode: true, lastClicked: new Date().getTime() });
                dispatch.lifeCycle.showResourecePane(null)
                dispatch.lifeCycle.splitAt("100%");
            } else {
                if (this.state.resourcePaneOpen) {
                    dispatch.lifeCycle.showResourecePane(this.props.resourcPane);
                    dispatch.lifeCycle.splitAt("60%");

                    this.setState({
                        resourcePaneOpen: false
                    })
                } else {
                    dispatch.lifeCycle.showResourecePane(this.props.resourcPane)
                    dispatch.lifeCycle.splitAt("60%");
                    this.setState({
                        resourcePaneOpen: true
                    })
                }
                this.setState({ lastClicked: new Date().getTime(), setEditMode: false });
            }
        }
        else {
            if (this.props.showResourecePaneFlag) {
                dispatch.lifeCycle.showResourecePane(this.props.resourcPane)
            }
            this.setState({ setEditMode: false, lastClicked: new Date().getTime(), resourcePaneOpen: true });
            this.props.getSelection(selectedMap.node.label.props.id);
        }

        this.props.setParent(selectedMap.parent ? selectedMap.parent.node.label.props.label : "");
        dispatch.lifeCycle.setIdToCenterPosition(selectedMap.node.label.props.id)
    }

    setEditModeFalse = () => {
        this.setState({ setEditMode: false })
    }
    componentWillMount() {
        dispatch.lifeCycle.setIdToCenterPosition(null);
    }

    render() {

        let length = this.props.selectedPracticeLibrary[this.props.elements] ? this.props.selectedPracticeLibrary[this.props.elements].filter((node) => { return !node.isLeafNode }).length : 0;
        let treeLabelWithColor;
        let components = [];
        const thisObject = this;
        const getDataNode = function (treeData = [], container, depth) {
            treeData.forEach(function (treeNode, index) {
                treeLabelWithColor = <span>{treeNode.parentCommunity ? <span> <span className="colorTag" style={{ 'background': treeNode.tagColor }}></span> {treeNode.name}  </span> : <span> {treeNode.name} </span>}</span>
                if (!treeNode.isLeafNode) {
                    const dataNode = {
                        label: (
                            <MenuNode
                                automationId={"automationId_" + thisObject.props.elements + '_' + depth + '_' + index}
                                label={treeNode.name}
                                colorTag={treeNode.tagColor}
                                id={treeNode._id}
                                name={treeNode.name}
                                isLeafCommunity={treeNode.communities && treeNode.communities.length === 0 ? true : false}
                                key={treeNode._id}
                                handleAdd={thisObject.handleAdd}
                                handleDelete={thisObject.handleDelete}
                                dataChanged={thisObject.dataChanged}
                                handleDnD={thisObject.treeDnDAction}
                                handlePeer={thisObject.handlePeer}
                                depth={depth}
                                treeLength={length}
                                validatioFunction={thisObject.inputValidation}
                                status={thisObject.props.selectedPracticeLibrary.status}
                                element={thisObject.props.elements}
                                setUniqueId={thisObject.props.setUniqueId}
                                setEditMode={treeNode._id === thisObject.props.setUniqueId && thisObject.state.setEditMode}
                                setEditModeFalse={thisObject.setEditModeFalse}
                                resourcPane={thisObject.props.resourcPane}
                            />
                        ),
                        raci: treeNode.raci
                    };
                    if (thisObject.props.elements === 'activities')
                        dataNode.icon = thisObject.props.selectedPracticeFlowActivity && thisObject.props.selectedPracticeFlowActivity.dependencies && thisObject.props.selectedPracticeFlowActivity.dependencies.indexOf(treeNode._id) !== -1 ? <Icon color='orange' name="unlinkify" /> : ""
                    if (treeNode[thisObject.props.elements] && treeNode[thisObject.props.elements].length && depth < 1) {
                        dataNode.nodes = [];


                        getDataNode(treeNode[thisObject.props.elements], dataNode.nodes, depth + 1);
                    }

                    container.push(dataNode);
                }
            });
        };
        getDataNode(this.props.selectedPracticeLibrary[this.props.elements], components, 0);
        return (
            <div>
                <TreeView
                    className={`designerTree ${this.props.className} ${appendClass} `}
                    defaultCollapsed={{
                        "0/0/1": true,
                        "0/1": true,
                        "0/2": true,
                        "0/3": true
                    }}
                    dataSource={components}

                    enableHoverStyle={false}
                    enableSelection={true}
                    singleSelect={true}
                    onSelectionChange={selectedMap => {
                        this.onSelectionChange(selectedMap);
                    }}
                    enableKeyboardNavigation={false}
                />
            </div >
        );
    }
}

export default PracticeFlowTreePage;